import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  SignupCredentials,
  SignupPayload,
  VerifySignupOtpPayload,
} from "./types";

interface RequestState {
  saving: boolean;
  error: boolean;
}

export interface CreateAccountState {
  signup: RequestState;
  credentials: SignupCredentials | null;
  verifyOtp: RequestState;
  resendOtp: RequestState;
}

export const initialState: CreateAccountState = {
  signup: { saving: false, error: false },
  credentials: null,
  verifyOtp: { saving: false, error: false },
  resendOtp: { saving: false, error: false },
};

export const createAccountSlice = createSlice({
  name: "createAccount",
  initialState,
  reducers: {
    saveSignup(state, { payload }: PayloadAction<SignupPayload>) {
      state.signup.saving = true;
      state.signup.error = false;
      state.credentials = {
        full_name: payload.full_name,
        email: payload.email,
        password: payload.password,
        confirm_password: payload.confirm_password,
      };
    },
    signupSaved(state) {
      state.signup.saving = false;
      state.signup.error = false;
    },
    signupSavingError(state) {
      state.signup.saving = false;
      state.signup.error = true;
    },

    saveVerifySignupOtp(
      state,
      _action: PayloadAction<VerifySignupOtpPayload>,
    ) {
      state.verifyOtp.saving = true;
      state.verifyOtp.error = false;
    },
    verifySignupOtpSaved(state) {
      state.verifyOtp.saving = false;
      state.verifyOtp.error = false;
    },
    verifySignupOtpError(state) {
      state.verifyOtp.saving = false;
      state.verifyOtp.error = true;
    },

    resendSignupOtp(state) {
      state.resendOtp.saving = true;
      state.resendOtp.error = false;
    },
    resendSignupOtpSaved(state) {
      state.resendOtp.saving = false;
      state.resendOtp.error = false;
    },
    resendSignupOtpError(state) {
      state.resendOtp.saving = false;
      state.resendOtp.error = true;
    },
  },
});

export const {
  saveSignup,
  signupSaved,
  signupSavingError,
  saveVerifySignupOtp,
  verifySignupOtpSaved,
  verifySignupOtpError,
  resendSignupOtp,
  resendSignupOtpSaved,
  resendSignupOtpError,
} = createAccountSlice.actions;

export const { reducer } = createAccountSlice;
